import { SCHEDULER } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetIssueRequest extends IBaseRequest {
    ident: string;
    userId: string;
}

export class GetIssueRequest extends BaseRequest implements IGetIssueRequest {
    public ident: string;
    public userId: string;

    constructor(server: string, session: string, ident: string, userId: string) {
        super(server, session);
        this.ident = ident;
        this.userId = userId;
    }

    public toXml(): string {
        let parameters: string = super.toXml();

        parameters += this.makeNode(this.ident, 'ident');
        parameters += this.makeNode(this.userId, 'userId');

        return super.wrapperXml(SCHEDULER.getIssue, parameters);
    }
}
